import { render, staticRenderFns } from "./NoteEdit.vue?vue&type=template&id=10205bb7"
import script from "./NoteEdit.vue?vue&type=script&lang=js"
export * from "./NoteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoteRedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteRedactorInput.vue').default})
